// Author liang gang qiang
// Date 2023-09-27 08:43:03

import * as model from "@/model/sithMesII/plan/SithMomMainProjectPlanModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMomMainProjectPlan(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMESII_PLAN_URL,
    })
    .buildStore()
